import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TrailPropertiesService } from '../../service/trail-properties.service';
import { BoolDto } from '../../../../common/dto/bool-dto';
import { TrailMachinery } from '../../dto/trail-machinery';

@Component({
  selector: 'dpi-trail-machinery-detail',
  imports: [MatInputModule, MatFormFieldModule, MatSelectModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './trail-machinery-detail.component.html',
  styleUrl: './trail-machinery-detail.component.scss'
})
export class TrailMachineryDetailComponent {
  readonly dialogRef = inject(MatDialogRef<TrailMachineryDetailComponent>);
  trailMachinery: TrailMachinery;
  isToUpdate: boolean;
  isToDelete: boolean;
  
  checkedStates: BoolDto[];
  selectedState: BoolDto;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TrailMachinery, private trailPropertiesService: TrailPropertiesService) {
    this.trailMachinery = data;
    this.isToUpdate = false;
    this.isToDelete = false;

    this.checkedStates = this.trailPropertiesService.getAllTrialBinaryStates();
    this.selectedState = this.trailPropertiesService.getTrialSetupBinaryState(this.checkedStates, data.maintenance_check);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.trailMachinery.maintenance_check = this.selectedState.state;
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }

}
